import { Row, Col, Form, Button } from 'react-bootstrap';
import PercentageField from '../fields/PercentageField';
import { availableIncomeMeasurementTypes } from '../../../utils/incomeMeasurementUtils';
import { AMI, FPL, MAX_AMI, MAX_FPL_OR, MAX_FPL_WA, MAX_SMI, SMI, STATES } from '../../../constants/constants';
import { useFormValidated } from './FormValidationContext';
import { useState } from 'react';

const IncomeMeasurementSelector = ({
  state,
  incomeMeasurementType,
  onIncomeMeasurementTypeChange,
  incomeMeasurementPercentage,
  onIncomeMeasurementPercentageChange,
  isSubmitting,
  required
}) => {

  const validated = useFormValidated();
  const [touched, setTouched] = useState(false);

  const isInvalid = required && (touched || validated) && !incomeMeasurementType;

  const handleChange = (e) => {
    onIncomeMeasurementTypeChange(e.target.value);
    setTouched(true);
  };

  const handleBlur = () => {
    setTouched(true);
  };

  const getMaxPercentage = () => {
    if (!incomeMeasurementType) return 0;
    switch (incomeMeasurementType) {
      case AMI:
        return MAX_AMI;
      case SMI:
        return MAX_SMI;
      case FPL:
        return state == STATES.WA? MAX_FPL_WA: MAX_FPL_OR
      default:
        return 0;
    }
  }

  return (
    <>
      {/* Income Measurement Type */}
      <Row className="d-flex justify-content-between align-items-center">
        <Col>
        <h4>Income Information{!required && <span className="text-muted fs-6"> • Optional</span>}</h4>
        </Col>
        {!required && incomeMeasurementType && (
          // If these fields are optional...
          // Allow clearing of fields once they have been populated
          <Col className="d-flex justify-content-end">
            <Button
              variant="outline-secondary"
              onClick={() => {
                onIncomeMeasurementTypeChange('');
                onIncomeMeasurementPercentageChange('');
              }}
            >Clear Selection</Button>
          </Col>
        )}
      </Row>
      <Row>
        <Col md={6}>
        <Form.Group as="fieldset">
          <Form.Label as="legend" className={required? 'required-field': ''}>
            Income Measurement Type
          </Form.Label>

          <div className="radio-group" onBlur={handleBlur}>
            {availableIncomeMeasurementTypes(state).map((type, i) => (
              <Form.Check
                key={type.value}
                name="incomeMeasurementType"
                type="radio"
                label={`${type.value} (${type.label})`}
                id={`${type.value}-(${type.label})`}
                value={type.value}
                checked={incomeMeasurementType === type.value}
                onChange={handleChange}
                disabled={isSubmitting}
                required={i===0 && required}
                isInvalid={isInvalid}
              />
            ))}
          </div>

          <Form.Control.Feedback
            type="invalid"
            className={isInvalid && validated ? 'd-block' : undefined}
          >
            Please select an Income Measurement Type.
          </Form.Control.Feedback>
        </Form.Group>
        </Col>

        {incomeMeasurementType && (
          <>
            <Col className="mt-3">
              <PercentageField
                value={incomeMeasurementPercentage}
                max={getMaxPercentage()}
                fieldName={`${incomeMeasurementType} Percentage`}
                required={required || incomeMeasurementType != null} // all or nothing
                readonly={incomeMeasurementType == null}
                onChange={onIncomeMeasurementPercentageChange}
                disabled={isSubmitting}
              />
              {!required && <Form.Text className="text-muted">{incomeMeasurementType} Percentage is required when you select '{incomeMeasurementType}' as the Income Measurement Type. Click the 'Clear Selection' button if Income Measurement Data is not needed.</Form.Text>}
            </Col>
          </>
        )}
      </Row>
    </>
  );
};

export default IncomeMeasurementSelector;